import React from 'react';
import { Container, Spinner } from 'react-bootstrap';

const Loading = () => {
    return (
        <Container className='my-5 py-5 text-center'>
            <Spinner animation="border" variant="primary" />
        </Container>
    );
};

export default Loading;